import {INPUT_ERROR} from "../constants/constants";
import {getTraduction, traductionEnum} from "./traduction";

export function validateAddressLine1() {
    let addressLine1 = $(".address-contact");
    let addressLine1Text = <string>addressLine1.val();
    let addressLine1IsCorrect = addressLine1Text.trim().length > 0;

    if (addressLine1IsCorrect) {
        addressLine1.parent().removeClass(INPUT_ERROR);
        addressLine1.next().removeClass(INPUT_ERROR);
    } else {
        addressLine1.parent().addClass(INPUT_ERROR);
        addressLine1.next().addClass(INPUT_ERROR);
        addressLine1.next().children().last().text(getTraduction(traductionEnum.ADDRESS_LINE1_REQUIRED));
    }

    return addressLine1IsCorrect;
}

export function validateProvince() {
    let province = $("#province-contact");
    let provinceText = province.find('> .select > p').text();
    let provinceIsCorrect = provinceText !== getTraduction(traductionEnum.PROVINCE_PLACEHOLDER);
    let $selectOptions = province.find('> .select-options');

    if (provinceIsCorrect) {
        province.removeClass(INPUT_ERROR);
        $selectOptions.next().removeClass(INPUT_ERROR);
    } else {
        province.addClass(INPUT_ERROR);
        $selectOptions.next().addClass(INPUT_ERROR);
        $selectOptions.next().children().last().text(getTraduction(traductionEnum.PROVINCE_REQUIRED));
    }

    return provinceIsCorrect;
}

export function validatePhoneType() {
    let phoneType = $("#telephone-type-contact");
    let phoneTypeText = phoneType.find("> .select > p").text();
    let phoneTypeIsCorrect = phoneTypeText !== "Type";
    let $selectOptions = phoneType.find('> .select-options');

    if (phoneTypeIsCorrect) {
        phoneType.removeClass(INPUT_ERROR);
        $selectOptions.next().removeClass(INPUT_ERROR);
    } else {
        phoneType.addClass(INPUT_ERROR);
        $selectOptions.next().addClass(INPUT_ERROR);
        $selectOptions.next().children().last().text(getTraduction(traductionEnum.PHONE_TYPE_REQUIRED));
    }

    return phoneTypeIsCorrect;
}

export function validateCity() {
    let city = $(".city-contact");
    let cityText = <string>city.val();
    let cityIsCorrect = cityText.trim().length > 0;

    manageErrorClassOn(city, cityIsCorrect, traductionEnum.CITY_REQUIRED);

    return cityIsCorrect;
}

export function validateBirthYear() {
    let birthYear = $(".birth-contact");
    let birthYearLength = (<string>birthYear.val()).trim().length;
    if (birthYearLength < 1) {
        manageErrorClassOn(birthYear, false, traductionEnum.BIRTH_YEAR_REQUIRED);
        return false;
    }

    let birthYearValue = Number(<string>birthYear.val());
    let currentYear = new Date().getFullYear();
    let birthYearIsIncorrect = isNaN(birthYearValue);
    if (birthYearIsIncorrect) {
        manageErrorClassOn(birthYear, false, traductionEnum.BIRTH_YEAR_REQUIRED);
        return false;
    }

    if (currentYear - birthYearValue <= 15) {
        manageErrorClassOn(birthYear, false, traductionEnum.NOT_OLD_ENOUGH);
        return false;
    }

    if (birthYearValue < 1890) {
        manageErrorClassOn(birthYear, false, traductionEnum.BIRTH_YEAR_LESS_THAN_1890);
        return false;
    }
    manageErrorClassOn(birthYear, true, traductionEnum.BIRTH_YEAR_LESS_THAN_1890);
    return true;
}

export function validatePhoneNumber($telephone: JQuery<HTMLElement>, isOptional: boolean = false) {
    if (isOptional) {
        // when optional empty string is considered ok
        if (!$telephone.val()) return true;
    }

    let phoneNumberLength = (<string>$telephone.val()).trim().length;
    if (phoneNumberLength < 1) {
        manageErrorClassOn($telephone, false, traductionEnum.PHONE_NUMBER_REQUIRED);
        return false;
    }

    let phoneRegex = new RegExp('[0-9]{3}-?[0-9]{3}-?[0-9]{4}');
    let isPhoneNumberCorrect = phoneRegex.test(<string>$telephone.val());

    manageErrorClassOn($telephone, isPhoneNumberCorrect, traductionEnum.ERROR_MSG_INVALID_GENERIC);

    return isPhoneNumberCorrect;
}

export function validatePostalCode() {
    let postalCode = $(".postal-code-contact");
    let postalCodeRegex = new RegExp('^(?!.*[dDfFiIoOqQuU])[a-vxyA-VXY][0-9][a-zA-Z] ?[0-9][a-zA-Z][0-9]$');

    if ((<string>postalCode.val()).trim().length < 1) {
        manageErrorClassOn(postalCode, false, traductionEnum.POSTAL_CODE_REQUIRED);
    }

    let isPostalCodeCorrect = postalCodeRegex.test(<string>postalCode.val());
    manageErrorClassOn(postalCode, isPostalCodeCorrect, traductionEnum.POSTAL_CODE_FORMAT_ERROR);

    return isPostalCodeCorrect;
}

export function validateCardNumber() {
    let cardNumber = $(".card-number");
    let cardNumberRegex = new RegExp('[0-9]{5}-?[0-9]{9}-?[0-9]');

    let isCardNumberCorrect = cardNumberRegex.test(<string>cardNumber.val());

    manageErrorClassOn(cardNumber, isCardNumberCorrect, traductionEnum.ERROR_CARD_NUMBER);

    // Set error message
    $('#card-number-error-msg').text(getTraduction(traductionEnum.ERROR_CARD_NUMBER));

    return isCardNumberCorrect;
}

export function manageErrorClassOn(element: JQuery<HTMLElement>, isValid: boolean, traduction: traductionEnum) {
    if (isValid) {
        // Information is used for permanent information under form label
        element.parent().find("~ .information")?.removeClass('hidden')
        element.parent().removeClass(INPUT_ERROR);
        element.next().removeClass(INPUT_ERROR);
        if (!element.next().hasClass('hidden')) element.next().addClass('hidden');
    } else {
        element.parent().find("~ .information")?.addClass('hidden')
        element.parent().addClass(INPUT_ERROR);
        element.next().addClass(INPUT_ERROR);
        element.next().removeClass('hidden');
        element.next().children().last().text(getTraduction(traduction));
    }
}